import*as o from"axios";import{getAugmentedNamespace as m}from"./_commonjsHelpers.mjs";var r=m(o);export{r as default};
